<!--
  Пример кастомного попапа на BasePopup (без стилей CommonPopup).
  Используйте такой вариант, когда CommonPopup не подходит или в проекте несколько типов попапов.
-->
<template>
  <BasePopup @close="handleClose">
    <div class="player-preview-popup">
      <button
        type="button"
        class="player-preview-popup__close"
        aria-label="Закрыть"
        @click="handleClose"
      >
        ×
      </button>
      <TypographyComp
        preset="heading-s"
        as="h2"
        class="player-preview-popup__title"
      >
        Мануэль Нойер
      </TypographyComp>
      <div class="player-preview-popup__fields">
        <div class="player-preview-popup__row">
          <span class="player-preview-popup__label">
            <TypographyComp preset="text-xs">
              Страна
            </TypographyComp>
          </span>
          <TypographyComp preset="text-s">
            Германия
          </TypographyComp>
        </div>
        <div class="player-preview-popup__row">
          <span class="player-preview-popup__label">
            <TypographyComp preset="text-xs">
              Клуб
            </TypographyComp>
          </span>
          <TypographyComp preset="text-s">
            Bayern München
          </TypographyComp>
        </div>
        <div class="player-preview-popup__row">
          <span class="player-preview-popup__label">
            <TypographyComp preset="text-xs">
              Позиция
            </TypographyComp>
          </span>
          <TypographyComp preset="text-s">
            Голкипер
          </TypographyComp>
        </div>
        <div class="player-preview-popup__row">
          <span class="player-preview-popup__label">
            <TypographyComp preset="text-xs">
              Возраст
            </TypographyComp>
          </span>
          <TypographyComp preset="text-s">
            39 лет
          </TypographyComp>
        </div>
      </div>
      <section class="player-preview-popup__fact">
        <span class="player-preview-popup__label">
          <TypographyComp preset="text-xs">
            Интересный факт
          </TypographyComp>
        </span>
        <TypographyComp
          preset="text-s"
          as="p"
        >
          Немецкий футболист, вратарь. Выступает за «Баварию» и сборную Германии. Считается одним из лучших голкиперов мира. Известен игрой на выходах и уверенной работой ногами.
        </TypographyComp>
      </section>
      <TypographyComp
        preset="text-s"
        as="p"
        class="player-preview-popup__lorem"
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
      </TypographyComp>
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import BasePopup from '@common/components/popups/BasePopup.vue';
import { usePopup } from '@common/composables/usePopup';

const { closePopup } = usePopup();

const handleClose = () => {
  closePopup();
};
</script>

<style lang="scss" scoped>
.player-preview-popup {
  position: fixed;
  bottom: 0;
  left: 1.6rem;
  right: 1.6rem;
  top: 15vh;
  background: $color-liga-black;
  border-radius: 1.6rem 1.6rem 0 0;
  padding: 2.4rem 2rem 3rem;
  overflow: auto;
  color: $color-white;
  box-shadow: 0 -4px 24px $color-black-40;

  @include layout-not-mobile {
    width: 56.8rem;
    max-width: calc(100vw - 3.2rem);
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    border-radius: 1.6rem 1.6rem 0 0;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &__close {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: $color-white;
    font-size: 2.4rem;
    line-height: 1;
    cursor: pointer;
    padding: 0;
  }

  &__title {
    margin: 0 0 1.6rem;
  }

  &__fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem 2rem;
    margin: 0 0 1.6rem;
    padding-bottom: 1.6rem;
    border-bottom: 1px dashed rgba($color-white, 0.3);
  }

  &__row {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin: 0;
  }

  &__label {
    color: $color-gray;
  }

  &__fact {
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    margin-bottom: 1.6rem;
  }

  &__lorem {
    margin: 0;
  }
}
</style>
